import Schema from "AppReact/schema";

export default {
  isOpen: Schema("boolean", "primitive", { defaultValue: false }),
  icon: Schema({}, 'object', { defaultValue: null })
};
